<template>
  <div id="page-user-edit">
    <vs-alert
      color="danger"
      title="Product Not Found"
      :active.sync="user_not_found"
    >
      <span
        >Product record with id: {{ $route.params.userId }} not found.
      </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Products</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="product_data" class="pb-10">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div id="user-edit-tab-info">
            <div class="vx-row mt-10">
              <div class="vx-col w-full md:w-1/2">
                <div class="flex items-end">
                  <feather-icon
                    icon="UserIcon"
                    class="mr-2"
                    svgClasses="w-5 h-5"
                  />
                  <span class="leading-none font-medium"
                    >Product Information</span
                  >
                </div>
              </div>
            </div>

            <div class="vx-row mt-0">
              <div class="vx-col w-full md:w-1/2">
                <div>
                  <vs-input
                    class="w-full mt-4"
                    label="Name"
                    v-model="product_data.name"
                    v-validate="'required'"
                    name="name"
                  />
                </div>

                <div class="mt-4">
                  <label class="vs-input--label">Client</label>
                  <v-select
                    v-model="product_data.client"
                    :clearable="false"
                    :options="clientOptions"
                    v-validate="'required'"
                    name="client"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('client')"
                    >{{ errors.first("client") }}</span
                  >
                </div>
              </div>

              <div class="vx-col w-full md:w-1/2">
                <div class="flex flex-wrap w-full">
                  <div class="mt-4 w-1/2 pr-2">
                    <label class="vs-input--label">Validity</label>
                    <v-select
                      v-model="product_data.validity"
                      :clearable="false"
                      :options="validityOptions"
                      v-validate="'required'"
                      name="validity"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('validity')"
                      >{{ errors.first("validity") }}</span
                    >
                  </div>
                  <div class="mt-4 w-1/2 pl-2">
                    <vs-input
                      class="w-full"
                      label="Quantity"
                      type="number"
                      v-model="quantity"
                      v-validate="'required|min_value:1'"
                      name="quantity"
                      min="1"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('quantity')"
                      >{{ errors.first("quantity") }}</span
                    >
                  </div>
                </div>

                <div class="flex flex-wrap w-full">
                  <div class="mt-4 w-1/2 pr-2">
                    <label class="text-sm">Sale price</label>
                    <vx-input-group>
                      <vs-input
                        v-model="product_data.sale_price"
                        name="sale_price"
                      />
                      <template slot="append">
                        <div class="append-text bg-primary">
                          <span>TND</span>
                        </div>
                      </template>
                    </vx-input-group>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Sale price')"
                      >{{ errors.first("Sale price") }}</span
                    >
                  </div>
                  <div class="mt-4 w-1/2 pl-2">
                    <label class="text-sm">Percentage</label>
                    <vx-input-group>
                      <vs-input
                        v-model="product_data.percentage"
                        v-validate="'between:0,100'"
                        name="percentage"
                      />
                      <template slot="append">
                        <div class="append-text bg-primary">
                          <span>%</span>
                        </div>
                      </template>
                    </vx-input-group>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('Percentage')"
                      >{{ errors.first("Percentage") }}</span
                    >
                  </div>

                  <div
                    class="mt-4 w-1/2 pr-2"
                    v-if="product_data.sale_price && product_data.percentage"
                  >
                    Client price: {{ client_price }}
                  </div>
                  <div
                    class="mt-4 w-1/2 pl-2"
                    v-if="product_data.sale_price && product_data.percentage"
                  >
                    Benefit: {{ benefit }}
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button
                    id="button-with-loading"
                    class="ml-auto mt-2"
                    @click.prevent="save_changes"
                    :disabled="!validateForm || sending"
                    >Save Changes</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr,
  },
  data() {
    return {
      sending: false,
      quantity: 1,
      product_data: {
        name: null,
        validity: null,
        sale_price: null,
        percentage: null,
        client: null,
      },
      user_not_found: false,
      clientOptions: [],
      validityOptions: [
        { label: "30 Jours", value: 30 },
        { label: "60 Jours", value: 60 },
      ],
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    client_price() {
      if (this.product_data.sale_price && this.product_data.percentage) {
        return (
          this.product_data.sale_price -
          (
            this.product_data.sale_price *
            (this.product_data.percentage / 100)
          ).toFixed()
        );
      }
      return null;
    },
    benefit() {
      if (this.product_data.sale_price && this.product_data.percentage) {
        return (
          this.product_data.sale_price *
          (this.product_data.percentage / 100)
        ).toFixed();
      }
      return null;
    },
  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    capitalize_snake(str) {
      return (str.slice(0, 1).toUpperCase() + str.slice(1, str.length))
        .split("_")
        .join(" ");
    },
    async save_changes() {
      this.sending = true;
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#button-with-loading",
        scale: 0.45,
      });
      const validationResult = await this.$validator.validateAll();
      const oldClient = this.product_data.client;
      const oldValidity = this.product_data.validity;
      const oldPercentage = this.product_data.percentage;
      this.product_data.benefit = +this.benefit;
      this.product_data.client_price = +this.client_price;
      this.product_data.sale_price = +this.product_data.sale_price;
      this.product_data.percentage = +this.product_data.percentage;
      if (validationResult) {
        const quantity = Math.max(1, Number(this.quantity)) || 1;
        const baseProductPayload = {
          ...this.product_data,
          validity: +this.product_data.validity.value,
          client: this.product_data.client.value,
        };
        let createdCount = 0;
        try {
          for (let i = 0; i < quantity; i++) {
            const productPayload = {
              ...baseProductPayload,
              name: quantity > 1 ? `${baseProductPayload.name}` : baseProductPayload.name,
            };
            await this.$store.dispatch("ADD_PRODUCT", productPayload);
            createdCount++;
          }
          // Reset form (keep client, percentage, and validity)
          this.product_data = {
            name: null,
            validity: oldValidity,
            sale_price: null,
            percentage: oldPercentage,
            client: oldClient,
          };
          this.quantity = 1;
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.$vs.notify({
            title: "Success",
            text: `Created ${createdCount} product${createdCount > 1 ? 's' : ''}`,
            color: "success",
            position: "top-center",
          });
          this.sending = false;
          // Clear validation errors
          this.$validator.reset();
        } catch (error) {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.sending = false;
          const errorMessage = (error && error.response && error.response.data && error.response.data.message) || (error && error.message) || String(error);
          this.$vs.notify({
            title: "Erreur",
            text: `Failed to create product${createdCount > 0 ? ` (${createdCount} created before error)` : ''}: ${errorMessage}`,
            color: "danger",
            position: "top-center",
          });
        }
      } else {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.sending = false;
        return;
      }
    },
  },
  async beforeMount() {
    await this.$store.dispatch("CLIENTS_REQUEST_LIGHTWEIGHT");
    this.clientOptions = this.$store.getters.getAllClientsForFilters.map((client) => ({
      label: client.display,
      value: client._id,
    }));
  },
};
</script>
